export const cookies = {
    consent: {
        headline: 'Wir Verwenden Cookies',
        declaration:
            'Wir nutzen Cookies auf unserer Webseite. Einige von ihnen sind essenziell, während andere uns helfen, diese Webseite und Ihre Erfahrung zu verbessern',
        acceptEssential: 'Essenziell',
        acceptMarketing: 'Marketing',
        acceptStatistics: 'Statistik',
        save: 'Speichern',
        acceptAll: 'Alle akzeptieren',
        revoke: 'Alle zurückziehen',
    },
    settings: {
        title: 'Cookie-Einstellungen',
    }
};
